require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/category-tabs/category-tabs.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/category-tabs/category-tabs.legacy.js
// module id = 710
// module chunks = 31